import axios from "axios";
import { apiUrl } from "../../config/constants";

import { selectUser } from "../user/selectors";
import { selectRestaurantById } from "../restaurants/selectors";
import { fetchRestaurantById } from "../restaurants/actions";

export const dishesFetched = (dishes) => ({
  type: "DISHES_FETCHED",
  payload: dishes,
});

export function fetchDishes(apiId) {
  return async function thunk(dispatch, getState) {
    try {
      const response = await axios.get(`${apiUrl}/apiId/${apiId}`);

      const dishes = response.data.dishes;

      dispatch(dishesFetched(dishes));
    } catch (e) {
      console.log(e);
    }
  };
}

export function postReview(overall, size, presentation, taste, benefit, id) {
  return async function thunk(dispatch, getState) {
    const { token } = selectUser(getState());
    const { apiId } = selectRestaurantById(getState());

    try {
      const response = await axios.post(
        `${apiUrl}/dishes/${id}/rates`,
        { overall, size, presentation, taste, benefit },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      console.log(response);

      dispatch(fetchRestaurantById(apiId));
    } catch (e) {
      console.log(e);
    }
  };
}

export function newDish(
  name,
  description,
  overallRate,
  sizeRate,
  presentationRate,
  tasteRate,
  benefitRate,
  restaurantId
) {
  return async function thunk(dispatch, getState) {
    const { token } = selectUser(getState());
    const { apiId } = selectRestaurantById(getState());

    try {
      const response = await axios.post(
        `${apiUrl}/apiId/${restaurantId}/dishes`,
        {
          name,
          description,
          overallRate,
          sizeRate,
          presentationRate,
          tasteRate,
          benefitRate,
          restaurantId,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      dispatch(fetchRestaurantById(apiId));
      console.log(response);
    } catch (e) {
      console.log(e);
    }
  };
}
